<div class="loading" *ngIf="loading">
  <div class="spinner-border" role="status"></div>
</div>

<div class="component-editor editor-shell container-component" *ngIf="!loading">
  <div class="editor-header">
    <div>
      <h3 class="editor-title">{{ 'EDIT_COMPONENT' | translate }}</h3>
      <p class="editor-subtitle">{{ 'COMPONENT_EDITOR_EDIT_SUBTITLE' | translate }}</p>
    </div>
  </div>

  <div class="stepper">
    <div class="stepper-progress">
      <div class="stepper-progress-bar" [style.width.%]="stepProgress"></div>
    </div>
    <div class="stepper-nav">
      <div *ngFor="let step of steps" class="stepper-chip" [class.is-active]="isCurrentStep(step.index)" [class.is-complete]="isStepComplete(step.index)" (click)="goToStep(step.index)" style="cursor: pointer;">
        <span class="stepper-index">{{ step.index }}</span>
        <div>
          <div class="stepper-label">{{ step.label | translate }}</div>
          <small>{{ step.description | translate }}</small>
        </div>
      </div>
    </div>
  </div>

  <form [formGroup]="componentForm" (ngSubmit)="validateFormData()">
    <div formGroupName="component">
      <section class="step-card" *ngIf="currentStep === 1">
        <div class="step-card-header">
          <div>
            <h4 class="step-card-title">{{ 'COMPONENT_STEP_1_TITLE' | translate }}</h4>
            <p class="step-card-copy">{{ 'EDIT_COMPONENT_STEP_1_COPY' | translate }}</p>
          </div>
        </div>

        <div class="section-grid">
          <div class="section-block">
            <label class="section-label" for="componentName">{{ 'COMPONENT_NAME' | translate }}</label>
            <input id="componentName" type="text" class="form-control" formControlName="componentName" maxlength="40" />
            <div class="error-text" *ngIf="shouldShowControlError(componentGroup.get('componentName'))">
              {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('COMPONENT_NAME' | translate) } }}
            </div>
          </div>

          <div class="section-block">
            <label class="section-label">{{ 'COMPONENT_TYPE' | translate }}</label>
            <span class="readonly-pill">{{ selectedParentId ? (parentIdNames[selectedParentId] | translate) : componentMeta?.componentTypeName }}</span>
          </div>
        </div>

        <div class="section-grid single-column">
          <div class="section-block is-muted">
            <label class="section-label">{{ 'SUBSCRIPTIONS' | translate }}</label>
            <div class="switch-title-container">
              <span>{{ 'SUBSCRIPTIONS_RESTRICT_VISIBILITY' | translate }}</span>
              <label class="switch">
                <input type="checkbox" [checked]="activeSubscriptions === 1" (change)="toggle()" />
                <span class="slider"></span>
              </label>
            </div>
            <p class="helper-text" *ngIf="activeSubscriptions === 0">{{ 'SUBSCRIPTIONS_ARE_NOT_RESTRICT' | translate }}</p>
            <div class="subscription-list" *ngIf="activeSubscriptions === 1">
              <label class="subscription-chip" *ngFor="let suscripcion of clientSubscriptions">
                <input type="checkbox" [checked]="selectedSubscriptions.includes(suscripcion.clientSubscriptionId)" (change)="toggleSuscripcion(suscripcion.clientSubscriptionId)" />
                {{ suscripcion.clientSubscriptionName }}
              </label>
            </div>
          </div>
        </div>

        <div class="section-grid single-column" *ngIf="selectedParentId === 3">
          <div class="section-block">
            <label class="section-label">{{ 'PRODUCT_SOURCE' | translate }}</label>
            <div class="option-inline-group">
              <label class="option-chip">
                <input type="radio" name="productSource" value="collections" (change)="onOptionChange('collections')" [checked]="selectedOption === 'collections'" />
                {{ 'COLLECTIONS' | translate }}
              </label>
              <label class="option-chip">
                <input type="radio" name="productSource" value="categories" (change)="onOptionChange('categories')" [checked]="selectedOption === 'categories'" />
                {{ 'CATEGORIES' | translate }}
              </label>
              <label class="option-chip">
                <input type="radio" name="productSource" value="subCategories" (change)="onOptionChange('subCategories')" [checked]="selectedOption === 'subCategories'" />
                {{ 'SUBCATEGORY' | translate }}
              </label>
              <label class="option-chip">
                <input type="radio" name="productSource" value="subSubcategories" (change)="onOptionChange('subSubcategories')" [checked]="selectedOption === 'subSubcategories'" />
                {{ 'SUB_SUBCATEGORIES' | translate }}
              </label>
            </div>

            <div class="error-text" *ngIf="navigationAttempted && !selectedOption">
              {{ 'FIELD_SELECTION_REQUIRED' | translate:{ field: ('PRODUCT_SOURCE' | translate) } }}
            </div>

            <div class="section-grid" *ngIf="selectedOption">
              <div class="section-block" *ngIf="selectedOption === 'collections'">
                <label class="section-label" for="collections">{{ 'COLLECTIONS' | translate }}</label>
                <select class="form-select" id="collections" formControlName="collectionId" (change)="onCollectionChange($event)">
                  <option [value]="0">{{ 'SELECT_COLLECTION' | translate }}</option>
                  <option *ngFor="let collection of collections" [value]="collection.collectionId">{{ collection.collectionName }}</option>
                </select>
              </div>

              <div class="section-block" *ngIf="selectedOption === 'categories'">
                <label class="section-label" for="category">{{ 'CATEGORIES' | translate }}</label>
                <select class="form-select" id="category" formControlName="categoryId" (change)="onCategoryChange($event)">
                  <option [value]="0">{{ 'SELECT_CATEGORY' | translate }}</option>
                  <option *ngFor="let category of categories" [value]="category.categoryId">{{ category.categoryName }}</option>
                </select>
              </div>

              <div class="section-block" *ngIf="selectedOption === 'subCategories'">
                <label class="section-label" for="subCategory">{{ 'SUBCATEGORY' | translate }}</label>
                <select class="form-select" id="subCategory" formControlName="subCategoryId" (change)="onSubCategoryChange($event)">
                  <option [value]="0">{{ 'SELECT_CATEGORY' | translate }}</option>
                  <option *ngFor="let subCategory of subCategories" [value]="subCategory.subCategoryId">{{ subCategory.subCategoryName }}</option>
                </select>
              </div>

              <div class="section-block" *ngIf="selectedOption === 'subSubcategories'">
                <label class="section-label" for="subSubCategory">{{ 'SUB_SUBCATEGORIES' | translate }}</label>
                <select class="form-select" id="subSubCategory" formControlName="subSubCategoryId" (change)="onSubSubCategoryChange($event)">
                  <option [value]="0">{{ 'SELECT_SUB_SUBCATEGORY' | translate }}</option>
                  <option *ngFor="let subSubCategory of subSubCategories" [value]="subSubCategory.subSubCategoryId">{{ subSubCategory.subSubCategoryName }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="step-card" *ngIf="currentStep === 2">
        <div class="step-card-header">
          <div>
            <h4 class="step-card-title">{{ 'COMPONENT_STEP_2_TITLE' | translate }}</h4>
            <p class="step-card-copy">{{ 'EDIT_COMPONENT_STEP_2_COPY' | translate }}</p>
          </div>
        </div>

        <div class="section-grid single-column">
          <div class="section-block">
            <label class="section-label" id="componentTypeDesignId">{{ 'LAYOUT' | translate }}</label>
            <div class="layout-selection layout-selection--readonly" role="radiogroup" aria-labelledby="componentTypeDesignId" aria-readonly="true">
              <div
                *ngFor="let design of layoutOptions; trackBy: trackByLayoutOption"
                class="layout-card layout-card--readonly"
                [class.is-active]="true">
                <input
                  class="layout-card-input"
                  type="radio"
                  name="componentTypeDesignIdReadonly"
                  [checked]="true"
                  disabled
                  tabindex="-1"
                  aria-hidden="true" />
                <span class="layout-card-media">
                  <img
                    *ngIf="design.imageUrl; else editLayoutFallback"
                    [src]="sanitizeURL(design.imageUrl)"
                    [alt]="design.name" />
                  <ng-template #editLayoutFallback>
                    <span class="layout-card-fallback" aria-hidden="true">
                      <span class="layout-card-fallback-badge">{{ selectedParentId ? (parentIdNames[selectedParentId] | translate) : ('LAYOUT' | translate) }}</span>
                      <span class="layout-card-fallback-name">{{ design.name }}</span>
                    </span>
                  </ng-template>
                </span>
                <span class="layout-card-copy">
                  <span class="layout-card-title">{{ design.name }}</span>
                </span>
              </div>
            </div>
            <div class="error-text" *ngIf="shouldShowControlError(componentGroup.get('componentTypeId'))">
              {{ 'FIELD_SELECTION_REQUIRED' | translate:{ field: ('LAYOUT' | translate) } }}
            </div>
          </div>
        </div>

        <div class="section-grid single-column" *ngIf="visibleFields.has('itemQuantity')">
          <div class="section-block">
            <label class="section-label" for="componentAmount">{{ 'ITEMS_QUANTITY' | translate }}</label>
            <select class="form-select" id="componentAmount" formControlName="itemQuantity" (change)="onItemQuantityChange($event)">
              <option [value]="0">{{ 'SELECT_ITEMS_QUANTITY' | translate }}</option>
              <option *ngFor="let quantity of [4, 8, 12, 16]" [value]="quantity">{{ quantity }}</option>
            </select>
            <div class="error-text" *ngIf="shouldShowControlError(componentGroup.get('itemQuantity'))">
              {{ 'FIELD_SELECTION_REQUIRED' | translate:{ field: ('ITEMS_QUANTITY' | translate) } }}
            </div>
          </div>
        </div>
      </section>

      <section class="step-card" *ngIf="currentStep === 3">
        <div class="step-card-header">
          <div>
            <h4 class="step-card-title">{{ 'COMPONENT_STEP_3_TITLE' | translate }}</h4>
            <p class="step-card-copy">{{ 'EDIT_COMPONENT_STEP_3_COPY' | translate }}</p>
          </div>
        </div>

        <div class="editor-toolbar">
          <div class="language-toggle" role="tablist" [attr.aria-label]="'LANGUAGE_SELECTOR' | translate">
            <button type="button" class="language-toggle__button" [class.is-active]="selectedLanguage === 'es'" (click)="selectLanguage('es')">{{ 'SPANISH' | translate }}</button>
            <button type="button" class="language-toggle__button" [class.is-active]="selectedLanguage === 'en'" (click)="selectLanguage('en')">{{ 'ENGLISH' | translate }}</button>
          </div>

          <div class="translation-status" [hidden]="selectedLanguage !== 'en'">
            <span class="readonly-pill">{{ (manualTranslationEnabled ? 'MANUAL_TRANSLATION_ENABLED' : 'AUTOMATIC_TRANSLATION_READONLY') | translate }}</span>
            <label class="switch">
              <input type="checkbox" [checked]="manualTranslationEnabled" (change)="onManualTranslationToggle($event)" />
              <span class="slider"></span>
            </label>
          </div>
        </div>

        <div class="section-grid single-column">
          <div [hidden]="selectedLanguage !== 'es'">
            <div class="section-block" [hidden]="!visibleFields.has('title')">
              <label class="section-label" for="componentTitle">{{ 'TITLE' | translate }}</label>
              <div class="quill-shell">
                <quill-editor id="componentTitle" class="title-editor" formControlName="title" [modules]="modules"></quill-editor>
              </div>
              <div class="error-text" *ngIf="shouldShowControlError(componentGroup.get('title'))">
                {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('TITLE' | translate) } }}
              </div>
            </div>

            <div class="section-block" [hidden]="!visibleFields.has('subtitle')">
              <label class="section-label" for="componentSubtitle">{{ 'SUBTITLE' | translate }}</label>
              <div class="quill-shell">
                <quill-editor id="componentSubtitle" class="subtitle-editor" formControlName="subtitle" [modules]="modules"></quill-editor>
              </div>
              <div class="error-text" *ngIf="shouldShowControlError(componentGroup.get('subtitle'))">
                {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('SUBTITLE' | translate) } }}
              </div>
            </div>

            <div class="section-block" [hidden]="!visibleFields.has('description')">
              <label class="section-label" for="description-edit">{{ 'DESCRIPTION' | translate }}</label>
              <div class="quill-shell">
                <quill-editor id="description-edit" class="description-editor" formControlName="description" [modules]="modules" (onEditorChanged)="descriptionChanged($event)"></quill-editor>
              </div>
              <div class="helper-text">{{ 'REMAINING_CHARACTERS' | translate }}: {{ remainingCharacters }} / {{ maxLength }}</div>
              <div class="error-text" *ngIf="shouldShowControlError(componentGroup.get('description'))">
                {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('DESCRIPTION' | translate) } }}
              </div>
            </div>

            <div class="section-block" [hidden]="!visibleFields.has('shopContactMail')">
              <label class="section-label" for="shopContactMail">{{ 'SHOP_CONTACT_MAIL' | translate }}</label>
              <input id="shopContactMail" type="email" class="form-control" formControlName="shopContactMail" maxlength="100" />
              <div class="error-text" *ngIf="shouldShowControlError(componentGroup.get('shopContactMail'))">
                {{ 'VALID_EMAIL_MESSAGE' | translate }}
              </div>
            </div>
          </div>

          <div class="translation-panel" [hidden]="selectedLanguage !== 'en'">
            <div class="translation-header">
              <div>
                <label class="section-label">{{ 'ENGLISH_CONTENT' | translate }}</label>
                <p class="helper-text" *ngIf="isEnglishReadonly">{{ 'ENGLISH_READONLY_HELPER' | translate }}</p>
                <p class="helper-text" *ngIf="!isEnglishReadonly">{{ 'ENGLISH_MANUAL_HELPER' | translate }}</p>
              </div>
              <div class="helper-text" *ngIf="!hasEnglishPreview">{{ 'ENGLISH_NO_PERSISTED_FALLBACK' | translate }}</div>
            </div>

            <div class="translation-preview" [hidden]="!isEnglishReadonly">
              <div class="translation-preview-copy" [hidden]="!visibleFields.has('title')">
                <label class="section-label">{{ 'ENGLISH_TITLE' | translate }}</label>
                <div class="translation-preview-html" [innerHTML]="englishTranslation.title"></div>
                <div class="helper-text" *ngIf="!englishTranslation.title">{{ 'NO_CONTENT_AVAILABLE_YET' | translate }}</div>
              </div>
              <div class="translation-preview-copy" [hidden]="!visibleFields.has('subtitle')">
                <label class="section-label">{{ 'ENGLISH_SUBTITLE' | translate }}</label>
                <div class="translation-preview-html" [innerHTML]="englishTranslation.subtitle"></div>
                <div class="helper-text" *ngIf="!englishTranslation.subtitle">{{ 'NO_CONTENT_AVAILABLE_YET' | translate }}</div>
              </div>
              <div class="translation-preview-copy" [hidden]="!visibleFields.has('description')">
                <label class="section-label">{{ 'ENGLISH_DESCRIPTION' | translate }}</label>
                <div class="translation-preview-html" [innerHTML]="englishTranslation.description"></div>
                <div class="helper-text" *ngIf="!englishTranslation.description">{{ 'NO_CONTENT_AVAILABLE_YET' | translate }}</div>
              </div>
            </div>

            <div class="translation-grid" [hidden]="isEnglishReadonly">
              <div class="translation-field" [hidden]="!visibleFields.has('title')">
                <label class="section-label">{{ 'ENGLISH_TITLE' | translate }}</label>
                <div class="quill-shell">
                  <quill-editor
                    class="title-editor"
                    [ngModel]="englishTranslation.title"
                    (ngModelChange)="updateEnglishField('title', $event)"
                    [ngModelOptions]="{ standalone: true }"
                    [modules]="modules"
                    name="edit-english-title">
                  </quill-editor>
                </div>
                <div class="error-text" *ngIf="shouldShowTranslationFieldError('title')">{{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('ENGLISH_TITLE' | translate) } }}</div>
              </div>

              <div class="translation-field" [hidden]="!visibleFields.has('subtitle')">
                <label class="section-label">{{ 'ENGLISH_SUBTITLE' | translate }}</label>
                <div class="quill-shell">
                  <quill-editor
                    class="subtitle-editor"
                    [ngModel]="englishTranslation.subtitle"
                    (ngModelChange)="updateEnglishField('subtitle', $event)"
                    [ngModelOptions]="{ standalone: true }"
                    [modules]="modules"
                    name="edit-english-subtitle">
                  </quill-editor>
                </div>
                <div class="error-text" *ngIf="shouldShowTranslationFieldError('subtitle')">{{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('ENGLISH_SUBTITLE' | translate) } }}</div>
              </div>

              <div class="translation-field" [hidden]="!visibleFields.has('description')">
                <label class="section-label">{{ 'ENGLISH_DESCRIPTION' | translate }}</label>
                <div class="quill-shell">
                  <quill-editor
                    class="description-editor"
                    [ngModel]="englishTranslation.description"
                    (ngModelChange)="updateEnglishField('description', $event)"
                    [ngModelOptions]="{ standalone: true }"
                    [modules]="modules"
                    name="edit-english-description">
                  </quill-editor>
                </div>
                <div class="error-text" *ngIf="shouldShowTranslationFieldError('description')">{{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('ENGLISH_DESCRIPTION' | translate) } }}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <section class="step-card" *ngIf="currentStep === 4">
      <div class="step-card-header">
        <div>
          <h4 class="step-card-title">{{ 'COMPONENT_STEP_4_TITLE' | translate }}</h4>
          <p class="step-card-copy">{{ 'EDIT_COMPONENT_STEP_4_COPY' | translate }}</p>
        </div>
      </div>

      <div class="items-shell" *ngIf="usesInfoTabs; else noItemsTemplate">
        <div class="editor-toolbar editor-toolbar--items">
          <div class="language-toggle" role="tablist" [attr.aria-label]="'LANGUAGE_SELECTOR_ITEMS' | translate">
            <button type="button" class="language-toggle__button" [class.is-active]="selectedLanguage === 'es'" (click)="selectLanguage('es')">{{ 'SPANISH' | translate }}</button>
            <button type="button" class="language-toggle__button" [class.is-active]="selectedLanguage === 'en'" (click)="selectLanguage('en')">{{ 'ENGLISH' | translate }}</button>
          </div>

          <div class="translation-status" [hidden]="selectedLanguage !== 'en'">
            <span class="readonly-pill">{{ (manualTranslationEnabled ? 'MANUAL_TRANSLATION_ENABLED' : 'AUTOMATIC_TRANSLATION_READONLY') | translate }}</span>
            <label class="switch">
              <input type="checkbox" [checked]="manualTranslationEnabled" (change)="onManualTranslationToggle($event)" />
              <span class="slider"></span>
            </label>
          </div>
        </div>

        <div class="tabs-row">
          <button *ngFor="let field of infoFields.controls; let i = index; trackBy: trackByIndex" type="button" class="item-tab" [class.is-active]="selectedIndex === i" [class.is-valid]="getTabState(i) === 'valid'" [class.is-error]="getTabState(i) === 'error'" (click)="selectItem(i)">
            <span class="tab-dot" [class.is-valid]="getTabState(i) === 'valid'" [class.is-incomplete]="getTabState(i) === 'incomplete'" [class.is-error]="getTabState(i) === 'error'"></span>
            {{ 'ITEM_WITH_INDEX' | translate:{ index: i + 1 } }}
          </button>
          <button type="button" class="add-tab-btn" (click)="addNewField()">+</button>
        </div>

        <div class="item-panels" *ngIf="infoFields.length > 0; else emptyItemTemplate">
          <div
            *ngFor="let field of infoFields.controls; let i = index; trackBy: trackByIndex"
            class="item-panel"
            [id]="'edit-item-panel-' + i"
            [formGroup]="$any(field)"
            [hidden]="selectedIndex !== i">
            <div class="item-panel-header">
              <h5 class="item-panel-title">{{ 'ITEM_WITH_INDEX' | translate:{ index: i + 1 } }}</h5>
              <button type="button" class="delete-button" (click)="removeField(i)">x</button>
            </div>

            <div class="item-layout">
              <div class="item-form-column">
                <div class="section-block" [hidden]="!visibleFields.has('infoVideoUrl')">
                  <label class="section-label" [for]="'videoTypeSelect-' + i">{{ 'VIDEO_SOURCE' | translate }}</label>
                  <select class="form-select" [id]="'videoTypeSelect-' + i" formControlName="videoUrlType" (change)="onVideoSourceChange(i, $event)">
                    <option [value]="1">{{ 'UPLOAD_FILE' | translate }}</option>
                    <option [value]="2">{{ 'INSERT_VIDEO_URL' | translate }}</option>
                  </select>
                </div>

                <div class="section-block" [hidden]="!visibleFields.has('infoVideoUrl') || field.get('videoUrlType')?.value != 2">
                  <label class="section-label">{{ 'MANUAL_VIDEO_URL' | translate }}</label>
                  <input type="text" class="form-control" [value]="field.get('videoManualURL')?.value" (input)="handleVideoManualURLChange(i, $event)" placeholder="https://example.com/video.mp4" />
                </div>

                <div [hidden]="selectedLanguage !== 'es'">
                  <div class="section-block" [hidden]="!visibleFields.has('infoTitle')">
                    <label class="section-label" [for]="'infoTitle-' + i">{{ 'ITEM_TITLE' | translate }}</label>
                    <div class="quill-shell">
                      <quill-editor class="info-title-editor" [id]="'infoTitle-' + i" formControlName="infoTitle" [modules]="modules"></quill-editor>
                    </div>
                    <div class="error-text" *ngIf="shouldShowControlError(field.get('infoTitle'))">{{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('ITEM_TITLE' | translate) } }}</div>
                  </div>

                  <div class="section-block" [hidden]="!visibleFields.has('infoDescription')">
                    <label class="section-label" [for]="'infoDescription-' + i">{{ 'ITEM_DESCRIPTION' | translate }}</label>
                    <div class="quill-shell">
                      <quill-editor class="info-description-editor" [id]="'infoDescription-' + i" formControlName="infoDescription" [modules]="modules" (onEditorChanged)="infoDescriptionChanged($event, i)"></quill-editor>
                    </div>
                    <div class="helper-text">{{ 'REMAINING_CHARACTERS' | translate }}: {{ getInfoRemainingCharacters(i) }} / {{ infoMaxLength }}</div>
                    <div class="error-text" *ngIf="shouldShowControlError(field.get('infoDescription'))">{{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('ITEM_DESCRIPTION' | translate) } }}</div>
                  </div>

                  <div class="section-block" [hidden]="!visibleFields.has('urlName')">
                    <label class="section-label">{{ 'LINK_TEXT' | translate }}</label>
                    <input type="text" class="form-control" formControlName="urlName" maxlength="50" />
                    <div class="error-text" *ngIf="shouldShowControlError(field.get('urlName'))">{{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('LINK_TEXT' | translate) } }}</div>
                  </div>

                  <div class="section-block" [hidden]="!visibleFields.has('redirectUrl')">
                    <label class="section-label">{{ 'REDIRECT_URL' | translate }}</label>
                    <input type="text" class="form-control" formControlName="redirectUrl" placeholder="https://ejemplo.com" />
                    <div class="error-text" *ngIf="shouldShowControlError(field.get('redirectUrl'))">{{ 'INVALID_URL_FORMAT' | translate }}</div>
                  </div>
                </div>

                <div class="translation-panel translation-panel--item" [hidden]="selectedLanguage !== 'en'">
                  <div class="translation-header">
                    <div>
                      <label class="section-label">{{ 'ENGLISH_ITEM_WITH_INDEX' | translate:{ index: i + 1 } }}</label>
                      <p class="helper-text" *ngIf="isEnglishReadonly">{{ 'ENGLISH_ITEM_READONLY_HELPER' | translate }}</p>
                      <p class="helper-text" *ngIf="!isEnglishReadonly">{{ 'ENGLISH_ITEM_MANUAL_HELPER' | translate }}</p>
                    </div>
                  </div>

                  <div class="translation-preview" [hidden]="!isEnglishReadonly">
                    <div class="translation-preview-copy" [hidden]="!visibleFields.has('infoTitle')">
                      <label class="section-label">{{ 'ENGLISH_TITLE' | translate }}</label>
                      <div class="translation-preview-html" [innerHTML]="englishTranslation.infoFields[i].infoTitle"></div>
                      <div class="helper-text" *ngIf="!englishTranslation.infoFields[i].infoTitle">{{ 'NO_CONTENT_AVAILABLE_YET' | translate }}</div>
                    </div>
                    <div class="translation-preview-copy" [hidden]="!visibleFields.has('infoDescription')">
                      <label class="section-label">{{ 'ENGLISH_DESCRIPTION' | translate }}</label>
                      <div class="translation-preview-html" [innerHTML]="englishTranslation.infoFields[i].infoDescription"></div>
                      <div class="helper-text" *ngIf="!englishTranslation.infoFields[i].infoDescription">{{ 'NO_CONTENT_AVAILABLE_YET' | translate }}</div>
                    </div>
                    <div class="translation-preview-copy" [hidden]="!visibleFields.has('urlName')">
                      <label class="section-label">{{ 'ENGLISH_LINK_NAME' | translate }}</label>
                      <div class="translation-preview-text">{{ englishTranslation.infoFields[i].urlName || ('NO_CONTENT_AVAILABLE_YET' | translate) }}</div>
                    </div>
                    <div class="translation-preview-copy" [hidden]="!visibleFields.has('redirectUrl')">
                      <label class="section-label">{{ 'ENGLISH_REDIRECT_URL' | translate }}</label>
                      <div class="translation-preview-text">{{ englishTranslation.infoFields[i].redirectUrl || ('NO_CONTENT_AVAILABLE_YET' | translate) }}</div>
                    </div>
                  </div>

                  <div class="translation-grid" [hidden]="isEnglishReadonly">
                    <div class="translation-field" [hidden]="!visibleFields.has('infoTitle')">
                      <label class="section-label">{{ 'ENGLISH_TITLE' | translate }}</label>
                      <div class="quill-shell">
                        <quill-editor
                          class="info-title-editor"
                          [ngModel]="englishTranslation.infoFields[i].infoTitle"
                          (ngModelChange)="updateEnglishInfoField(i, 'infoTitle', $event)"
                          [ngModelOptions]="{ standalone: true }"
                          [modules]="modules"
                          [name]="'edit-english-info-title-' + i">
                        </quill-editor>
                      </div>
                      <div class="error-text" *ngIf="shouldShowTranslationInfoError(i, 'infoTitle')">{{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('ENGLISH_TITLE' | translate) } }}</div>
                    </div>

                    <div class="translation-field" [hidden]="!visibleFields.has('infoDescription')">
                      <label class="section-label">{{ 'ENGLISH_DESCRIPTION' | translate }}</label>
                      <div class="quill-shell">
                        <quill-editor
                          class="info-description-editor"
                          [ngModel]="englishTranslation.infoFields[i].infoDescription"
                          (ngModelChange)="updateEnglishInfoField(i, 'infoDescription', $event)"
                          [ngModelOptions]="{ standalone: true }"
                          [modules]="modules"
                          [name]="'edit-english-info-description-' + i">
                        </quill-editor>
                      </div>
                      <div class="error-text" *ngIf="shouldShowTranslationInfoError(i, 'infoDescription')">{{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('ENGLISH_DESCRIPTION' | translate) } }}</div>
                    </div>

                    <div class="translation-field" [hidden]="!visibleFields.has('urlName')">
                      <label class="section-label">{{ 'ENGLISH_LINK_NAME' | translate }}</label>
                      <input
                        type="text"
                        class="form-control"
                        [ngModel]="englishTranslation.infoFields[i].urlName"
                        (ngModelChange)="updateEnglishInfoField(i, 'urlName', $event)"
                        [ngModelOptions]="{ standalone: true }"
                        [name]="'edit-english-url-name-' + i"
                        maxlength="50" />
                      <div class="error-text" *ngIf="shouldShowTranslationInfoError(i, 'urlName')">{{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('ENGLISH_LINK_NAME' | translate) } }}</div>
                    </div>

                    <div class="translation-field" [hidden]="!visibleFields.has('redirectUrl')">
                      <label class="section-label">{{ 'ENGLISH_REDIRECT_URL' | translate }}</label>
                      <input
                        type="text"
                        class="form-control"
                        [ngModel]="englishTranslation.infoFields[i].redirectUrl"
                        (ngModelChange)="updateEnglishInfoField(i, 'redirectUrl', $event)"
                        [ngModelOptions]="{ standalone: true }"
                        [name]="'edit-english-redirect-url-' + i"
                        placeholder="https://example.com" />
                      <div class="error-text" *ngIf="shouldShowTranslationInfoError(i, 'redirectUrl')">{{ 'INVALID_URL_FORMAT' | translate }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="item-media-column">
                <div class="section-block" [hidden]="!visibleFields.has('infoImageUrl')">
                  <label class="section-label">{{ 'ITEM_IMAGE' | translate }}</label>
                  <div class="media-actions">
                    <button type="button" class="media-btn" (click)="triggerFileInput(i, 'image')">{{ 'UPLOAD_IMAGE' | translate }}</button>
                    <input [id]="'btn-upload-image-' + i" type="file" class="d-none" accept="image/*" (change)="handleFileSelection(i, $event, 'image')" />
                  </div>
                  <div class="media-preview" *ngIf="field.get('imageURL')?.value">
                    <img [src]="sanitizeURL(field.get('imageURL')?.value)" [alt]="'UPLOADED_IMAGE' | translate" />
                    <button type="button" class="delete-button" (click)="removeMedia(i, 'imageURL')">{{ 'REMOVE' | translate }}</button>
                  </div>
                  <div class="error-text" *ngIf="shouldShowControlError(field.get('imageURL'))">{{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('ITEM_IMAGE' | translate) } }}</div>
                </div>

                <div class="section-block" [hidden]="!visibleFields.has('infoVideoUrl')">
                  <label class="section-label">{{ 'ITEM_VIDEO' | translate }}</label>
                  <div class="media-actions" [hidden]="field.get('videoUrlType')?.value != 1">
                    <button type="button" class="media-btn" (click)="triggerFileInput(i, 'video')">{{ 'UPLOAD_VIDEO' | translate }}</button>
                    <input [id]="'btn-upload-video-' + i" type="file" class="d-none" accept="video/*" (change)="handleFileSelection(i, $event, 'video')" />
                  </div>

                  <div class="media-preview" *ngIf="field.get('videoURL')?.value">
                    <video #videoPlayer controls (loadedmetadata)="captureThumbnail(videoPlayer)">
                      <source [src]="sanitizeURL(field.get('videoURL')?.value)" type="video/mp4" />
                    </video>
                    <button type="button" class="delete-button" (click)="removeMedia(i, 'videoURL')">{{ 'REMOVE' | translate }}</button>
                  </div>

                  <div class="media-preview" *ngIf="field.get('videoUrlType')?.value == 2 && field.get('videoManualURL')?.value">
                    <iframe *ngIf="isYouTubeVideo(field.get('videoManualURL')?.value)" [src]="sanitizeVideoURL(field.get('videoManualURL')?.value)" frameborder="0" allowfullscreen></iframe>
                    <video *ngIf="!isYouTubeVideo(field.get('videoManualURL')?.value)" controls>
                      <source [src]="sanitizeURL(field.get('videoManualURL')?.value)" type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #emptyItemTemplate>
        <div class="section-block is-muted">
          <p class="helper-text">{{ 'ADD_ITEM_FOR_LAYOUT' | translate }}</p>
        </div>
      </ng-template>

      <ng-template #noItemsTemplate>
        <div class="section-block is-muted">
          <p class="helper-text">{{ 'LAYOUT_WITHOUT_DYNAMIC_ITEMS' | translate }}</p>
        </div>
      </ng-template>
    </section>

    <div class="step-actions" *ngIf="currentStep < 4">
      <button type="button" class="btn-step btn-secondary" (click)="prevStep()" [disabled]="currentStep === 1">{{ 'PREVIOUS' | translate }}</button>
      <button type="button" class="btn-step btn-primary" (click)="nextStep()">{{ 'NEXT' | translate }}</button>
    </div>

    <div class="form-buttons" *ngIf="currentStep === 4">
      <button type="button" class="btn-step btn-secondary" (click)="prevStep()">{{ 'PREVIOUS' | translate }}</button>
      <button type="submit" class="submit-btn">{{ 'SAVE' | translate }}</button>
    </div>
  </form>
</div>

<div class="modal component-confirm-modal fade" id="successEditComponentModal" tabindex="-1">
  <div class="modal-dialog component-modal-dialog" role="document">
    <div class="modal-content component-modal-content">
      <div class="modal-body component-modal-body">
        <h3 class="text-center">{{ 'SUCCESS' | translate }}</h3>
        <p class="text-center">{{ 'COMPONENT_SAVED_SUCCESS' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{ 'CLOSE' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal component-confirm-modal fade" id="errorEditComponentModal" tabindex="-1">
  <div class="modal-dialog component-modal-dialog" role="document">
    <div class="modal-content component-modal-content">
      <div class="modal-body component-modal-body">
        <h3 class="text-center">{{ 'ERROR' | translate }}</h3>
        <p class="text-center">{{ 'ERROR_SAVING_CHANGES' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{ 'CLOSE' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal component-confirm-modal fade" id="errorEditMaxMinItemModal" tabindex="-1">
  <div class="modal-dialog component-modal-dialog" role="document">
    <div class="modal-content component-modal-content">
      <div class="modal-body component-modal-body">
        <h3 class="text-center">{{ 'ERROR' | translate }}</h3>
        <p class="text-center">{{ errorMessage }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{ 'CLOSE' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal component-confirm-modal fade" id="errorFileSizeModal" tabindex="-1">
  <div class="modal-dialog component-modal-dialog" role="document">
    <div class="modal-content component-modal-content">
      <div class="modal-body component-modal-body">
        <h3 class="text-center">{{ 'ERROR' | translate }}</h3>
        <p class="text-center">{{ 'ERROR_FILE_SIZE' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{ 'CLOSE' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal component-confirm-modal fade" id="errorEditRedirectUrl" tabindex="-1">
  <div class="modal-dialog component-modal-dialog" role="document">
    <div class="modal-content component-modal-content">
      <div class="modal-body component-modal-body">
        <h3 class="text-center">{{ 'ERROR' | translate }}</h3>
        <p class="text-center">{{ 'INVALID_URL' | translate }}{{ itemListId }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{ 'CLOSE' | translate }}</button>
      </div>
    </div>
  </div>
</div>
